import { useFieldsObject } from './useFields';

export const useEnhancedZones = (zones = []) => {
  const fields = useFieldsObject();

  return zones.map(zone => {
    const newZone = {};

    Object.keys(zone).forEach(field => {
      let value = zone[field];

      if (fields[field] && fields[field].round) {
        const { round } = fields[field];
        value = Math.round(value * (10 ** round)) / (10 ** round);
      }

      if (value !== null && !Number.isNaN(+value)) {
        value = value.toLocaleString();
      }

      if (fields[field] && fields[field].suffix) {
        const { suffix } = fields[field];
        value = `${value} ${suffix}`;
      }

      if (value !== zone[field]) {
        newZone[`${field}_raw`] = zone[field];
      }

      newZone[field] = value;
    });

    return newZone;
  });
};

export default useEnhancedZones;
